//REACT
import React from 'react'

// nodejs library that concatenates classes
import classNames from "classnames";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import Button from "components/CustomButtons/Button.js";
//Componentes
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

//Estilo
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
const useStyles = makeStyles(headersStyle);
const useStylesBanner = makeStyles(() => ({
  pageHeader:{
    position: "relative",
    height: "100vh",
    maxHeight: "600px",
    backgroundPosition: "50%",
    backgroundSize: "cover",
    margin: "0",
    padding: "0",
    border: "0",
    display: "flex",
    WebkitBoxAlign: "center",
    MsFlexAlign: "center",
    alignItems: "center",

    "&:after,&:before": {
      position: "absolute",
      zIndex: "1",
      width: "100%",
      height: "100%",
      display: "block",
      left: "0",
      top: "0",
      content: "''"
    }
  }
}));
export default function ItemCarrusel(props) {
  const classes = useStyles();
  const classesBanner = useStylesBanner();
  return (
    <div>
      {
        props.tieneBtn ?
          <div
            className={classes.pageHeader}
            style={{ backgroundImage: `url("${props.imagen}")`, maxHeight: '400px' }}
          >
            <div className={classes.container}>
              <GridContainer>
                <GridItem
                  xs={12}
                  sm={8}
                  md={8}

                  className={classNames(
                    classes.mlAuto,
                    classes.mrAuto,
                    classes.textCenter
                  )}
                >
                  <div>
                    <h1 className={classes.title}>{props.titulo}</h1>
                    <h4>
                      {props.descripcion}
                    </h4>
                    <br />
                    <Link to={props.link} state="uno">
                      {props.titulo === "Certificado Digital SII. (Firma Simple)" ?
                        <Button round color="primary" size="m"  >
                          {props.txtBoton01}
                        </Button>
                        : null}
                      {props.titulo === "FIRMA AVANZADA" ?
                        <Button round color="primary" size="m"  >
                          {props.txtBoton02}
                        </Button>
                        : null}
                    </Link>
                  </div>
                </GridItem>
              </GridContainer>
            </div>
          </div>
          :
          <Link to={props.link} state="uno">
            <div
              className={classesBanner.pageHeader}
              style={{ backgroundImage: `url("${props.imagen}")`, maxHeight: '400px' }}
            ></div>
          </Link>
      }

    </div>
  )
}
